"use client";

import Button from "@/components/Button/Button";
import ErrorAlert from "@/components/Alerts/ErrorAlert/ErrorAlert";
import { StyledErrorPageWrapper } from "./error.styled";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <StyledErrorPageWrapper>
      <ErrorAlert
        error={error}
        fallbackErrorMessage="Something went wrong while loading the page. Please try again by reloading it."
      />
      <div>
        <Button onClick={() => reset()}>Reload the page</Button>
      </div>
    </StyledErrorPageWrapper>
  );
}
